// extracted by mini-css-extract-plugin
module.exports = {"app":"LongContentLayout_app__kijgr","appPrint":"LongContentLayout_appPrint__IXTBK"};